import { TypographyOptions } from "@mui/material/styles/createTypography";

// Configuration for the typography
const typography: TypographyOptions = {
  fontFamily: '"RO", Arial, sans-serif',
  htmlFontSize: 16,
};

export default typography;
